"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryFilterList = categoryFilterList;
exports.createLadderPrice = createLadderPrice;
exports.createLevel = createLevel;
exports.deleteLadderPrice = deleteLadderPrice;
exports.deleteLevel = deleteLevel;
exports.deleteVip = deleteVip;
exports.editVip = editVip;
exports.freeDelete = freeDelete;
exports.freeDetail = freeDetail;
exports.freeEdit = freeEdit;
exports.freeList = freeList;
exports.getListVip = getListVip;
exports.listExpress = listExpress;
exports.listLadderPrice = listLadderPrice;
exports.listLevel = listLevel;
exports.listMall = listMall;
exports.listOrder = listOrder;
exports.listWx = listWx;
exports.queryVip = queryVip;
exports.saveVip = saveVip;
exports.setEnabledVip = setEnabledVip;
exports.sortVip = sortVip;
exports.updateExpress = updateExpress;
exports.updateLadderPrice = updateLadderPrice;
exports.updateLevel = updateLevel;
exports.updateMall = updateMall;
exports.updateOrder = updateOrder;
exports.updateWx = updateWx;
var _request = _interopRequireDefault(require("@/utils/request"));
function listMall() {
  return (0, _request.default)({
    url: '/config/mall',
    method: 'get'
  });
}
function updateMall(data) {
  return (0, _request.default)({
    url: '/config/mall',
    method: 'post',
    data: data
  });
}
function listExpress() {
  return (0, _request.default)({
    url: '/config/express',
    method: 'get'
  });
}
function updateExpress(data) {
  return (0, _request.default)({
    url: '/config/express',
    method: 'post',
    data: data
  });
}
function listOrder() {
  return (0, _request.default)({
    url: '/config/order',
    method: 'get'
  });
}
function updateOrder(data) {
  return (0, _request.default)({
    url: '/config/order',
    method: 'post',
    data: data
  });
}
function listWx() {
  return (0, _request.default)({
    url: '/config/wx',
    method: 'get'
  });
}
function updateWx(data) {
  return (0, _request.default)({
    url: '/config/wx',
    method: 'post',
    data: data
  });
}
// 等级配置
function listLevel(data) {
  return (0, _request.default)({
    url: '/goods/userlevel/list',
    method: 'POST',
    data: data
  });
}
function createLevel(data) {
  return (0, _request.default)({
    url: '/goods/userlevel/create',
    method: 'POST',
    data: data
  });
}
function updateLevel(data) {
  return (0, _request.default)({
    url: '/goods/userlevel/update',
    method: 'POST',
    data: data
  });
}
function deleteLevel(data) {
  return (0, _request.default)({
    url: '/goods/userlevel/delete',
    method: 'POST',
    data: data
  });
}

// 阶梯价格配置
function listLadderPrice(data) {
  return (0, _request.default)({
    url: '/goods/ladder/list',
    method: 'POST',
    data: data
  });
}
function createLadderPrice(data) {
  return (0, _request.default)({
    url: '/goods/ladder/create',
    method: 'POST',
    data: data
  });
}
function updateLadderPrice(data) {
  return (0, _request.default)({
    url: '/goods/ladder/update',
    method: 'POST',
    data: data
  });
}
function deleteLadderPrice(data) {
  return (0, _request.default)({
    url: '/goods/ladder/delete',
    method: 'POST',
    data: data
  });
}
function categoryFilterList() {
  return (0, _request.default)({
    url: '/categoryFilter/list',
    method: 'get'
  });
}

// 会员文案配置
function editVip(data) {
  return (0, _request.default)({
    url: '/vip/intro/edit',
    method: 'POST',
    data: data
  });
}
function getListVip(data) {
  return (0, _request.default)({
    url: '/vip/intro/list',
    method: 'POST',
    data: data
  });
}
function deleteVip(data) {
  return (0, _request.default)({
    url: '/vip/intro/delete',
    method: 'POST',
    data: data
  });
}
function setEnabledVip(data) {
  return (0, _request.default)({
    url: '/vip/intro/setEnabled',
    method: 'POST',
    data: data
  });
}
function sortVip(data) {
  return (0, _request.default)({
    url: '/vip/intro/sort',
    method: 'POST',
    data: data
  });
}
// 会员可自由配置 保存
function saveVip(data) {
  return (0, _request.default)({
    url: '/vip/center/config/edit',
    method: 'POST',
    data: data
  });
}
// 回显
function queryVip(data) {
  return (0, _request.default)({
    url: '/vip/center/config/query',
    method: 'POST',
    data: data
  });
}
// 免费试用
// 添加or编辑
function freeEdit(data) {
  return (0, _request.default)({
    url: '/vip/free/activity/edit',
    method: 'POST',
    data: data
  });
}
// 删除

function freeDelete(data) {
  return (0, _request.default)({
    url: '/vip/free/activity/delete',
    method: 'POST',
    data: data
  });
}
// 获取列表
function freeList(data) {
  return (0, _request.default)({
    url: '/vip/free/activity/list',
    method: 'POST',
    data: data
  });
}
// 查看详情
function freeDetail(data) {
  return (0, _request.default)({
    url: '/vip/free/activity/query',
    method: 'POST',
    data: data
  });
}